export interface NavItem {
  label: string;
  href: string;
  children?: NavItem[];
}

// One-Pager Anchors + Karriere-Detailseite
export const navigationItems: NavItem[] = [
  { label: 'Karriere', href: '/karriere' },
  { label: 'Team', href: '/#team' },
  { label: 'FAQ', href: '/#faq' },
];
